function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { html as c } from "../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import { TestableLitElement as p } from "../../../utils/components/testable-lit-element/testable-lit-element.js";
import { customElement as u } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as n } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import d from "../../../packages/web-components/src/components/progress-ring/gator/progress-ring.gator.scss.js";
import g from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import f from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import "../../skeleton-loader/gator/skeleton-loader.gator.js";
import { unsafeCSS as h } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var v = Object.defineProperty,
  $ = Object.getOwnPropertyDescriptor,
  a = function a(e, t, r, o) {
    for (var i = o > 1 ? void 0 : o ? $(t, r) : t, l = e.length - 1, m; l >= 0; l--) (m = e[l]) && (i = (o ? m(t, r, i) : m(i)) || i);
    return o && i && v(t, r, i), i;
  };
var s = /*#__PURE__*/function (_p) {
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, arguments), _this.value = 0, _this.diameter = void 0, _this.size = "", _this.skeleton = !1, _this.variant = "";
    return _this;
  }
  _inherits(s, _p);
  return _createClass(s, [{
    key: "computedDiameter",
    get: function get() {
      return typeof this.diameter == "number" && !Number.isNaN(this.diameter) ? this.diameter : this.size === "large" ? 40 : 34;
    }
  }, {
    key: "clampedValue",
    get: function get() {
      return Number.isNaN(this.value) ? 0 : Math.max(0, Math.min(100, this.value));
    }
  }, {
    key: "radius",
    get: function get() {
      return this.computedDiameter / 2 - 2 / 2;
    }
  }, {
    key: "circumference",
    get: function get() {
      return 2 * Math.PI * this.radius;
    }
  }, {
    key: "dashOffset",
    get: function get() {
      var e = this.clampedValue / 100;
      return this.circumference * (1 - e);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this.computedDiameter,
        t = e / 2,
        r = "".concat(this.clampedValue, "%");
      return this.skeleton ? c(_templateObject || (_templateObject = _taggedTemplateLiteral(["<ngc-skeleton-loader width=\"", "\" height=\"", "\" radius=\"999\"></ngc-skeleton-loader>"])), this.computedDiameter, this.computedDiameter) : c(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <div class=\"gator-progress-ring\"\n                 role=\"progressbar\"\n                 aria-valuemin=\"0\"\n                 aria-valuemax=\"100\"\n                 aria-valuenow=\"", "\"\n                 aria-label=\"", "\"\n                 style=\"--ngc-progress-ring-diameter: ", "px\">\n                <svg class=\"ring\" width=\"", "\" height=\"", "\" viewBox=\"0 0 ", " ", "\">\n                    <circle\n                        class=\"track\"\n                        cx=\"", "\"\n                        cy=\"", "\"\n                        r=\"", "\"\n                        stroke-width=\"2\"\n                        fill=\"none\"\n                    ></circle>\n                    <circle\n                        class=\"progress\"\n                        cx=\"", "\"\n                        cy=\"", "\"\n                        r=\"", "\"\n                        stroke-width=\"2\"\n                        fill=\"none\"\n                        stroke-dasharray=\"", " ", "\"\n                        stroke-dashoffset=\"", "\"\n                        transform=\"rotate(-90 ", " ", ")\"\n                    ></circle>\n                </svg>\n                <div class=\"center\">\n                    <slot @slotchange=\"", "\">\n                        ", "\n                    </slot>\n                </div>\n            </div>\n        "])), this.clampedValue, r, e, e, e, e, e, t, t, this.radius, t, t, this.radius, this.circumference, this.circumference, this.dashOffset, t, t, this.handleSlotChange, this.variant === "" ? c(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"label\">", "</div>"])), this.clampedValue) : this.renderVariantIcon());
    }
  }, {
    key: "handleSlotChange",
    value: function handleSlotChange(e) {
      var r = e.target.assignedElements()[0];
      (r === null || r === void 0 ? void 0 : r.tagName.toLowerCase()) === "ngc-icon" && this.variant && r.setAttribute("type", this.variant);
    }
  }, {
    key: "renderVariantIcon",
    value: function renderVariantIcon() {
      var e = this.variant === "success" ? "check" : this.variant === "warning" ? "warning" : this.variant === "error" ? "restricted" : "sparkle",
        t = this.variant;
      return c(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<ngc-icon name=\"", "\" type=\"", "\" size=\"small\"></ngc-icon>"])), e, t);
    }
  }]);
}(p);
s.styles = [h(d), h(g), h(f)];
a([n({
  type: Number
})], s.prototype, "value", 2);
a([n({
  type: Number
})], s.prototype, "diameter", 2);
a([n({
  type: String
})], s.prototype, "size", 2);
a([n({
  type: Boolean
})], s.prototype, "skeleton", 2);
a([n({
  type: String,
  reflect: !0
})], s.prototype, "variant", 2);
s = a([u("ngc-progress-ring")], s);
export { s as NgcProgressRing };